import {
  BankAccountInfiniteSelectField,
  DocumentTypesInfiniteSelectField,
  FloatingFormItem,
} from '@/components/_common';
import {
  PlanAccountDestination,
  PlanAccountHierarchy,
} from '@/core/domain/enterprise/PlanAccounts/PlanAccounts.types';
import {
  Badge,
  Button,
  Checkbox,
  Col,
  Collapse,
  Form,
  FormInstance,
  Row,
} from 'antd';
import { useIntl } from 'react-intl';
import CostCenterInfiniteSelectField from '@/components/_common/CostCenterInfiniteSelectField';
import InsurerInfiniteSelectField from '@/components/_common/InsurerInfiniteSelectField';
import { useDisclosure, useWindowSize } from '@/hooks';
import CustomersSelectedModal from '@/components/_common/CustomersSelectedModal';
import { useState } from 'react';
import PlanAccountSeletedModal from '@/components/_common/PlanAccountSeletedModal';

interface Props {
  form: FormInstance;
}

const BillsToReceiveMoreOptions = ({ form }: Props) => {
  const intl = useIntl();
  const { isMobile } = useWindowSize();

  const [customerModal, customerModalAction] = useDisclosure();
  const [selectedCustomers, setSelectedCustomers] = useState<number[]>();

  const [planAccountOpened, planAccountActions] = useDisclosure();
  const [selectedPlanAccountIds, setSelectePlanAccountIds] =
    useState<number[]>();

  return (
    <Collapse>
      <Collapse.Panel
        key={1}
        header={intl.formatMessage({
          id: 'financial.billsToReceive.form.moreOptions',
        })}
      >
        <Row gutter={[24, 24]} align="middle">
          <Col xs={8}>
            <FloatingFormItem
              label={intl.formatMessage({
                id: 'financial.billsToReceive.form.moreOptions.insurers',
              })}
              name="insurersIds"
            >
              <InsurerInfiniteSelectField
                mode="multiple"
                allowClear
                queryFilter={{ active: undefined }}
              />
            </FloatingFormItem>
          </Col>

          <Col xs={8}>
            <FloatingFormItem
              label={intl.formatMessage({
                id: 'financial.billsToReceive.form.moreOptions.documentsTypes',
              })}
              name="documentTypeIds"
            >
              <DocumentTypesInfiniteSelectField
                allowClear
                mode="multiple"
                queryFilter={{ active: true }}
              />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={24} md={8}>
            <FloatingFormItem
              valuePropName="checked"
              name="isExcludedDocumentType"
            >
              <Checkbox>
                Ocultar os tipos de documentos selecionados no relatório
              </Checkbox>
            </FloatingFormItem>
          </Col>

          <Col xs={8}>
            <FloatingFormItem
              label={intl.formatMessage({
                id: 'release.form.costCenter',
              })}
              name="costCenterIds"
            >
              <CostCenterInfiniteSelectField
                mode="multiple"
                allowClear
                queryFilter={{ active: true }}
              />
            </FloatingFormItem>
          </Col>

          <Col xs={8}>
            <FloatingFormItem
              label={intl.formatMessage({
                id: 'financial.billsToReceive.form.moreOptions.banks',
              })}
              name="bankAccountIds"
            >
              <BankAccountInfiniteSelectField />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={24} md={8} xxl={4}>
            <Badge count={form.getFieldValue('planAccountIds')?.length}>
              <Button
                block
                type="primary"
                onClick={planAccountActions.open}
                size={isMobile ? 'middle' : 'large'}
              >
                Selecionar plano de contas
              </Button>
            </Badge>
          </Col>

          <Col xs={24} sm={24} md={8} xxl={4}>
            <Badge count={form.getFieldValue('customersIds')?.length}>
              <Button
                block
                type="primary"
                onClick={customerModalAction.open}
                size={isMobile ? 'middle' : 'large'}
              >
                {intl.formatMessage({
                  id: 'movementWorkOrdersReport.form.moreOptions.button.selectCustomers',
                })}
              </Button>
            </Badge>
          </Col>
        </Row>

        <Form.Item name="customersIds" noStyle>
          <CustomersSelectedModal
            visible={customerModal}
            handleVisible={customerModalAction.close}
            selectedCustomerIds={selectedCustomers}
            finishCallback={(customerIds) => {
              setSelectedCustomers(customerIds);
              form.setFieldValue('customersIds', customerIds);
            }}
          />
        </Form.Item>

        <Form.Item name="planAccountIds" noStyle>
          <PlanAccountSeletedModal
            open={planAccountOpened}
            onCancel={planAccountActions.close}
            queryFilter={{
              destination: PlanAccountDestination.Revenue,
              hierarchy: PlanAccountHierarchy.Analitical,
            }}
            selectedPlanAccounIds={selectedPlanAccountIds}
            finishCallback={(planAccountIds) => {
              setSelectePlanAccountIds(planAccountIds);
              form.setFieldValue('planAccountIds', planAccountIds);
            }}
          />
        </Form.Item>
      </Collapse.Panel>
    </Collapse>
  );
};

export default BillsToReceiveMoreOptions;
